/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

var tabPanelDefaultProps = {
  destroyOnHide: true,
  removable: false
};
var tabsDefaultProps = {
  addable: false,
  dragSort: false,
  placement: "top",
  size: "medium",
  theme: "normal"
};

export { tabPanelDefaultProps, tabsDefaultProps };
//# sourceMappingURL=defaultProps.js.map
